<script>
	import { scale, fly, fade, slide } from 'svelte/transition'
	import {
		circOut,
		quartInOut,
		sineInOut,
		sineOut,
		backOut,
	} from 'svelte/easing'
	import { tweened } from 'svelte/motion'
	import { onMount } from 'svelte'

	let svgWidth = Math.min(window.innerWidth * 0.9, 1050)
	let svgHeight = svgWidth * 0.251

	let hide
	let shown = false

	const svgWrapWidth = tweened(svgWidth * 0.24, {
		duration: 1600,
		easing: quartInOut,
	})

	// needs to go up to 42
	const upperPolygon = tweened([0, svgWidth * 0.02], {
		duration: 1600,
		easing: quartInOut,
	})

	// needs to go down to 45
	const lowerPolygon = tweened([85, svgWidth * -0.02], {
		duration: 1600,
		easing: quartInOut,
	})

	onMount(() => {
		setTimeout(() => {
			shown = true
		}, 0)
	})

	let growing
</script>

{#if !hide}
	<div class="home-intro">
		<div
			class="home-intro-background"
			out:slide={{ duration: 1750, easing: quartInOut }} />
		{#if shown}
			<div
				class="logo-wrap"
				class:growing
				style="width:{$svgWrapWidth}px"
				in:scale={{ duration: 1200, start: 1.5, opacity: 0 }}
				out:slide={{ duration: 1100, easing: quartInOut }}
				on:introend={() => {
					growing = true
					$svgWrapWidth = svgWidth
					$upperPolygon = [42, 0]
					$lowerPolygon = [45, 0]
					setTimeout(() => {
						hide = true
					}, 1800)
				}}>
				<svg
					viewBox="0 0 336 84.2"
					style="width:{svgWidth}px;height:{svgHeight}px;">
					<!-- upper words -->
					<g style="transform: translateY({$upperPolygon[1]}px)">
						<path
							d="M99.8 36.7h-10l-6 .2v-.2a1.6 1.6 0 000-.2l5-5.7 4.7-5.6
							4.5-6q2.5-3.5 4.4-6.6a84 84 0 00-7.3-.1 52.1 52.1 0 00-6 .2 5.6
							5.6 0 00-2.9 1 6.7 6.7 0 00-1.7 2.5l-.6-.3.5-1.5a44.6 44.6 0
							00.4-1.7l.4-1.9a2 2 0 010-.3.2.2 0 01.3-.2l.3.2a1.6 1.6 0 001.3.8
							9.3 9.3 0 001.3.1h4.3l14.3-.1v.3q-1.4 2-2.3 3l-2 2.7-1.9 2.4-.8
							1-4.3 5.6-1.5 2-1.1 1.4a163.4 163.4 0 00-2.9 3.7l-1.5 2a26.5 26.5
							0 005 .4 56.6 56.6 0 006.7-.3 15.3 15.3 0 004-1 5.2 5.2 0
							001.8-1.2 5.8 5.8 0 001-2l.6.4-1.1 3-1.2 2.7a1.2 1.2 0 01-.3
							0c0-.3-.3-.5-1-.6a38.6 38.6 0 00-4.4 0"
							fill="#002d62" />
						<path
							d="M127.9 31h.5a28.4 28.4 0 01-.6 3.2 14 14 0 01-1
							2.4h-1.5l-3-.1H112.5l-3.3.1V36l1.2-.3a2 2 0 00.8-.3 1 1 0 00.3-.5
							5.8 5.8 0 00.2-1l.2-2.4.2-4.1v-2.8l-.1-5.8a30.8 30.8 0 00-.2-3.7
							1.8 1.8 0 00-.6-1.2 4.7 4.7 0 00-1.7-.6 2.5 2.5 0
							010-.5h11.7l5.9-.1-.4 3.1q-.2 1.6-.6 1.6c-.3
							0-.4-.1-.4-.3v-.7l.1-.6q0-1.4-1.5-1.7a17 17 0 00-3.8-.4 42.8 42.8
							0 00-5.6.4 48 48 0 00-.3 5V24h2.7q3.8 0 5.2-.2a4.2 4.2 0 001.1-.2
							1.3 1.3 0 00.6-.6 10.4 10.4 0 00.5-1.6h.5v6.8h-.6a4.7 4.7 0
							00-.5-2.3 2.4 2.4 0 00-1.7-.9 38 38 0 00-4.5-.2 23.1 23.1 0
							00-3.3.2v2.6a40.2 40.2 0 00.2 7.4 28.9 28.9 0 001.7.4 23.4 23.4 0
							003 .2 18.5 18.5 0 004.5-.5 5 5 0 002.5-1.3 7.7 7.7 0 001.5-2.7"
							fill="#002d62" />
						<path
							d="M130.3 36.6l-.2-.7q2-.2 2.3-.8a13.9 13.9 0 00.5-4l.2-6.2v-6a25
							25 0 00-.1-3.5 2 2 0 00-.7-1.4 3.5 3.5 0 00-1.8-.4V13a9.1 9.1 0
							012-.2h1.8a19.2 19.2 0 002 .2h2.6a5 5 0 000 .5l-.9.2a4 4 0
							00-1.2.3 1.1 1.1 0 00-.5.7 15.7 15.7 0 00-.3 2.3q-.2 1.6-.2
							3.9v2.9h14.7a9.4 9.4 0 001.7-.2v-3.8-4a3.7 3.7 0 00-.3-1.1 1.3 1.3
							0 00-.6-.8 11.6 11.6 0 00-2-.5l.1-.7q.9 0 1.7.2a22.9 22.9 0 002.4
							0h3.8v.4l-.3.1a3.1 3.1 0 00-1.1.5 1.7 1.7 0 00-.6 1 7.3 7.3 0
							00-.2 1.4l-.2 3.9-.1 8.3a39.5 39.5 0 000 5 3.2 3.2 0 00.8 2 3.4
							3.4 0 001.8.6v.5a10.5 10.5 0 00-1.8-.2H151.8l-2.3.2V36a4 4 0
							001.7-.5 1.7 1.7 0 00.7-1.1 16.8 16.8 0
							00.2-2.7l.1-4.2v-2.4h-2l-10.4-.1h-4l-.1 6.3a13.7 13.7 0 00.2 3.3
							1.3 1.3 0 00.3.6 2 2 0 00.8.4 12.3 12.3 0
							001.6.4v.6h-1.4l-1.8-.2h-1.6l-3.5.2"
							fill="#002d62" />
						<path
							d="M170.6 28.4l-2.1-3a28.8 28.8 0 01-4-.1v7.3a8.1 8.1 0 00.4 2.4 1
							1 0 00.5.7 10.1 10.1 0 001.6.5q.4 0 .4.3c0
							.2-.1.4-.3.4l-1.5-.2-2-.2a27.4 27.4 0 00-3.6.3 1.9 1.9 0 00-.3
							0c-.2 0-.4 0-.4-.3a.3.3 0 01.2-.3 2.6 2.6 0 01.6-.2 2.2 2.2 0
							001.2-.7 3.6 3.6 0 00.5-1.7 38.8 38.8 0 00.2-4.1v-8-4.3a7.2 7.2 0
							00-.3-2 1.4 1.4 0 00-.8-1 6 6 0 00-1.5-.2v-.6a82.5 82.5 0
							005.7-.2l3.5-.3a10.7 10.7 0 013.5.6 8 8 0 012.5 1.4 5.9 5.9 0
							011.6 2 5.2 5.2 0 010 4.6 6.3 6.3 0 01-1.7 2 9.9 9.9 0 01-2.9
							1.6l.9 1.3 2.8 4.1q1.2 1.6 2.5 3a14.2 14.2 0 002.6 2.5 5.5 5.5 0
							002.7 1 .3.3 0 01.3.3.3.3 0 01-.2.3 2.3 2.3 0 01-.7 0 7.8 7.8 0
							01-3.4-.7 13 13 0 01-3.2-2 23 23 0 01-2.6-2.8 80.5 80.5 0
							01-2.7-3.7m-6-4.2a13.1 13.1 0 003 .3 14.8 14.8 0 001.8-.1 7.8 7.8
							0 002-.6 4.2 4.2 0 001.8-1.5 4.6 4.6 0 00.8-2.7 5.9 5.9 0
							00-.7-2.6 6 6 0 00-2-2.3 5.5 5.5 0 00-3.3-1 9.3 9.3 0
							00-1.8.3c-.7.1-1 .3-1.2.6q-.4 1-.4 9.6"
							fill="#002d62" />
						<path
							d="M203 32.9l-.8 3q-2 .7-3.8 1a18.2 18.2 0 01-3.7.4 13.7 13.7 0
							01-4.8-1 13 13 0 01-4.3-2.6 12.8 12.8 0 01-3-4.2 14 14 0
							01-1.2-5.8 12.8 12.8 0 012-7.4 12.6 12.6 0 015.4-4.5 16.3 16.3 0
							016.7-1.5 14 14 0 015.2 1 6.1 6.1 0 001.7.4 7.7 7.7 0 01.7 0 .4.4
							0 01.3 0l-.3 1.2a31.4 31.4 0 00-.7 3.9.6.6 0 01-.5-.3 1.3 1.3 0
							010-.6 3.9 3.9 0 00-.4-1.7 5.8 5.8 0 00-2.6-1.8 10.4 10.4 0
							00-4.3-1 9.2 9.2 0 00-5 1.5A9.8 9.8 0 00186 17a15.2 15.2 0 00-1.3
							6.6 14 14 0 001.1 6 11.2 11.2 0 003 3.9 11.7 11.7 0 003.5 2.1 9.3
							9.3 0 003 .7 7.5 7.5 0 003.6-.8A6.6 6.6 0 00201 34a16.2 16.2 0
							001.6-2.4c.2-.4.3-.6.5-.6a.3.3 0 01.3.4 10.6 10.6 0 01-.3 1.6"
							fill="#a9c5e7" />
						<path
							d="M225 31.1h.5a26.8 26.8 0 01-.7 3.2 14.1 14.1 0 01-.9 2.3 31.8
							31.8 0 00-4.5-.1h-10.1l-3.3.1V36l1.2-.3a2.1 2.1 0 00.8-.3 1 1 0
							00.3-.4 5.6 5.6 0 00.2-1l.2-2.5a171 171 0 00.2-6.8l-.1-5.7a30 30 0
							00-.2-3.6 1.8 1.8 0 00-.6-1.3 4.8 4.8 0 00-1.7-.5 2.3 2.3 0
							010-.5H218l6-.2a32.8 32.8 0 01-.3 3.2c-.2 1-.4 1.5-.6 1.5-.3 0-.5
							0-.5-.3v-.7l.1-.6q0-1.3-1.6-1.7a17.5 17.5 0 00-3.8-.4 44 44 0
							00-5.6.4 46 46 0 00-.3 5 219.8 219.8 0 000 4.8h2.7l5.3-.1a4.3 4.3
							0 001.1-.2 1.3 1.3 0 00.6-.7 10.2 10.2 0 00.5-1.5h.6V28.3h-.7a4.6
							4.6 0 00-.5-2.3 2.4 2.4 0 00-1.7-.8 39.3 39.3 0 00-4.6-.2 23.9
							23.9 0 00-3.3.2v2.5a39.2 39.2 0 00.3 7.3 26.5 26.5 0 001.6.4 23.7
							23.7 0 003.1.2 19 19 0 004.5-.5 5 5 0 002.5-1.3 7.6 7.6 0
							001.5-2.7"
							fill="#a9c5e7" />
						<path
							d="M226.3 13.5v-.8l2.1.2h1.1l1.6-.1a37 37 0 002.6 3q1.4 1.5 3.3
							3.2l2 2L250 31.2V20.8v-4.2a5.5 5.5 0 00-.6-2 1.9 1.9 0 00-1-1 12.2
							12.2 0 00-2-.4l.1-.5a7.3 7.3 0 011 0 32.8 32.8 0 012.4 0l1
							.1H253.9v.6a3.6 3.6 0 00-1.6.5 1.9 1.9 0 00-.6 1.1 38.1 38.1 0
							00-.5 5.8l-.1 8.3v3a168.9 168.9 0 00.1
							4.5h-.7q-1.3-2.7-7.6-8.6l-6.8-6.3-1.7-1.5-3.4-3.1-.3 11a27.7 27.7
							0 00.2 4.8 2.4 2.4 0 001 1.8 12 12 0 003 1 3 3 0 010
							.6h-1.7l-1.9-.1h-2.8l-1.2.2a.6.6 0 01-.4-.1.4.4 0 01-.1-.4v-.3a1.2
							1.2 0 01.5 0 3.3 3.3 0 001.1-.4 1.4 1.4 0 00.6-.7 7 7 0
							00.3-1.8l.2-3.1v-8.7a33.4 33.4 0 000-4.2 4.5 4.5 0 00-.9-2.2 3.2
							3.2 0 00-2.3-1"
							fill="#a9c5e7" />
						<path
							d="M256 17.1h-.6l1.5-4.4a4 4 0 00.7.5 2.6 2.6 0
							00.7.2l5.4.1h13.6a3.3 3.3 0 001-.2 1.5 1.5 0 00.6-.4 1.6 1.6 0
							00.5.5 22 22 0 00-1 3.7l-.8.1.1-1.6a3.9 3.9 0 00-1.6-.7 17.8 17.8
							0 00-3.6-.3H270a1.5 1.5 0 00-.7.2.8.8 0 00-.2.5l-.1 2.4-.1
							3.2v12.6a5 5 0 00.3 1.6 1.3 1.3 0 00.8.8 10.1 10.1 0 001.7.4c.6 0
							.9 0 .9.2a1.3 1.3 0 010 .4 5.6 5.6 0 01-.8 0 65.7 65.7 0 00-4-.2
							25.6 25.6 0 00-3.8.4c-.8 0-1.2.2-1.3.2a.5.5 0 01-.4-.2 1.4 1.4 0
							01-.2-.4l1.1-.3a12.4 12.4 0 001.8-.5 1.2 1.2 0 00.7-.6 3 3 0
							00.2-1.1 16.1 16.1 0 01.1-2v-2.3l.1-3.2v-2.3-5.6l-.1-2.6a5.5 5.5 0
							00-.3-1.4l-3.5-.1a27.9 27.9 0 00-3 0 5.5 5.5 0 00-1.7.5 2.1 2.1 0
							00-.8.7 9.4 9.4 0 00-.7 1.3"
							fill="#a9c5e7" />
						<path
							d="M300 31.4h.5a28.2 28.2 0 01-.6 3.2 14.6 14.6 0 01-1
							2.4l-1.6-.1h-3l-2.3-.1h-7.7l-3.3.2v-.7l1.2-.3a2 2 0 00.8-.3 1 1 0
							00.3-.4 5.9 5.9 0 00.2-1l.2-2.5a151.7 151.7 0 00.2-7l-.1-5.8a30.7
							30.7 0 00-.2-3.6 1.9 1.9 0 00-.6-1.3 4.7 4.7 0 00-1.7-.5 2.6 2.6 0
							010-.5h11.8l6-.2-.4 3.2c-.2 1-.4 1.6-.6 1.6-.3
							0-.5-.1-.5-.3v-.7l.2-.7q0-1.3-1.6-1.7a17.2 17.2 0 00-3.9-.3 43.8
							43.8 0 00-5.6.3 47.6 47.6 0 00-.3 5.2v4.8h2.7q3.9 0 5.3-.2a4.2 4.2
							0 001.1-.2 1.3 1.3 0 00.6-.6 10.7 10.7 0 00.5-1.6h.6v6.8h-.7a4.7
							4.7 0 00-.5-2.3 2.4 2.4 0 00-1.7-.9 39 39 0 00-4.6-.2 23.7 23.7 0
							00-3.3.2V28a40.4 40.4 0 00.3 7.4 24.8 24.8 0 001.6.4 25.4 25.4 0
							003.1.2 18.8 18.8 0 004.5-.4 5 5 0 002.5-1.4 7.8 7.8 0 001.5-2.7"
							fill="#a9c5e7" />
						<path
							d="M312.6 28l-2.1-2.9a28.9 28.9 0 01-4-.2v7.3a8 8 0 00.4 2.4 1 1 0
							00.5.7 10.2 10.2 0 001.5.5c.3 0 .4.1.4.3 0 .2 0
							.3-.2.3l-1.6-.1-1.9-.2a27.7 27.7 0 00-3.6.3 1.9 1.9 0 00-.3 0c-.3
							0-.4 0-.4-.3a.3.3 0 01.2-.3 2.6 2.6 0 01.6-.2 2.2 2.2 0 001.2-.7
							3.6 3.6 0 00.5-1.7 38.6 38.6 0 00.2-4.1v-8V17a7.4 7.4 0 00-.3-2
							1.4 1.4 0 00-.8-.9 6 6 0 00-1.5-.3V13a56.1 56.1 0
							005.7-.2l3.5-.2a10.7 10.7 0 013.4.5 8 8 0 012.6 1.4 5.9 5.9 0
							011.6 2 5.2 5.2 0 010 4.6 6.3 6.3 0 01-1.7 2 10 10 0 01-2.9 1.6l.9
							1.2 2.8 4.1q1.2 1.6 2.5 3a14.2 14.2 0 002.6 2.4 5.6 5.6 0 002.6 1
							.3.3 0 01.4.4.3.3 0 01-.2.3 2.3 2.3 0 01-.8 0 7.9 7.9 0 01-3.4-.7
							13 13 0 01-3-2 22.6 22.6 0 01-2.7-2.8 78 78 0
							01-2.7-3.6m-6-4.2a13.3 13.3 0 003 .2 14.8 14.8 0 001.8 0 7.8 7.8 0
							002-.6 4.2 4.2 0 001.8-1.5 4.5 4.5 0 00.7-2.7 5.8 5.8 0 00-.6-2.6
							6 6 0 00-2-2.3 5.5 5.5 0 00-3.3-1 9.3 9.3 0 00-1.8.3c-.7.1-1
							.3-1.2.6q-.4 1-.4 9.6"
							fill="#a9c5e7" />
						<polygon
							fill="#fff"
							points="80,{$upperPolygon[0]} 328,{$upperPolygon[0]} 328,42 80,42" />
					</g>
					<!-- lower words -->
					<g fill="#002d62" style="transform: translateY({$lowerPolygon[1]}px)">
						<path
							d="M105.4 55.6a8.4 8.4 0 018.5-6.8c4.2 0 6.4 2.5 5.7 6.5a8.6 8.6 0
							01-8.5 7c-5 0-6.2-3.7-5.7-6.7m11.6.3c.8-3.9-1-6.2-3.8-6.2-2 0-4.5
							1-5.3 5.3-.7 3.6.8 6.4 4 6.4 1.3 0 4.2-.5 5.1-5.5" />
						<path
							d="M127.3 54l.7-3.6c0-.6 0-.8-.6-1a3.7 3.7 0 00-.6 0c-.2 0-.3
							0-.3-.2l.4-.1h4.8a4.8 4.8 0 013 .7 2.5 2.5 0 01.7 2.4c-.2 1.3-1
							2.4-3 3.8 1.2 2 2 3.5 2.9 4.5a2.7 2.7 0 001.7 1.2 2.3 2.3 0 00.5
							0s.2.1.1.2c0 .1-.1.2-.3.2h-1.7a3.1 3.1 0 01-1.7-.3 6.3 6.3 0
							01-2-2.6l-1.1-2.3a.3.3 0 00-.3-.2H129a.1.1 0 00-.2.1v.3l-.7 3.7c0
							.5 0 .8.5.9a7 7 0 00.9 0s.2.1.1.2c0 .1-.1.2-.3.2h-4.6c-.3 0-.4
							0-.4-.2l.3-.1a2.8 2.8 0 00.7-.1c.3 0 .5-.4.6-1 .3-.7.5-2
							.8-3.6l.6-3m1.8 1.3v.3a4.2 4.2 0 001.4.2 2 2 0 001.2-.3 3.8 3.8 0
							001.5-2.6c.5-2.4-1-3.1-2-3.1a4 4 0 00-1 0 .3.3 0 00-.1.3z" />
						<path
							d="M146.6 50.3H144c-1 .1-1.4.2-1.8.6a2.7 2.7 0 00-.4.5c0
							.2-.1.2-.2.2l-.1-.2.7-2 .3-.3c.2 0 .3.2.7.2l1.7.1h6.9a8.9 8.9 0
							001.2 0 4.9 4.9 0 01.5-.2v.4l-.4 2-.2.2c-.1 0-.2
							0-.1-.3v-.2c0-.4-.3-1-1.9-1h-2.1l-1.4 6.9c-.3 1.5-.6 2.9-.6 3.6 0
							.5 0 .8.5.9a6.5 6.5 0 00.8 0c.2 0 .3.1.3.2l-.4.2h-4.9c-.2 0-.3
							0-.3-.2l.3-.1a2.9 2.9 0 00.7-.1c.3 0 .5-.4.6-1 .3-.6.5-2
							.8-3.5l1.4-6.9" />
						<path
							d="M168.4 54.6a.1.1 0 00.2 0v-.4l.7-3.6c0-.6 0-.9-.5-1a3.6 3.6 0
							00-.7 0c-.2 0-.3 0-.3-.2l.4-.2h4.6c.2 0 .4 0 .3.2 0 .1 0
							.2-.3.2a3.6 3.6 0 00-.5 0c-.5 0-.7.4-.8 1-.2.5-.2 1-.7 3.6l-.6
							3c-.3 1.5-.6 2.9-.6 3.6 0 .5 0 .8.4.9a6.1 6.1 0 001 0s.2.1.1.2c0
							.1-.1.2-.3.2H166c-.3 0-.4 0-.4-.2l.3-.1a2.7 2.7 0 00.6-.1c.4 0
							.5-.4.7-1l.8-3.5.3-1.5-.1-.1h-6.5a.1.1 0 00-.1 0l-.3 1.6c-.3
							1.5-.6 2.9-.6 3.6 0 .5 0 .8.5.9a6.1 6.1 0 00.8 0c.2 0
							.3.1.3.2l-.4.2H157.2c-.2 0-.3 0-.3-.2l.3-.1a2.7 2.7 0 00.6-.1c.4 0
							.5-.4.7-1l.8-3.5.6-3 .6-3.6c0-.6 0-.9-.5-1a3.6 3.6 0 00-.7 0c-.2
							0-.3 0-.2-.2 0-.1.1-.2.4-.2h4.5c.3 0 .4 0 .3.2 0 .1 0 .2-.3.2a3.5
							3.5 0 00-.5 0c-.5 0-.7.4-.8 1l-.7 3.6-.1.3v.1h6.6" />
						<path
							d="M177.9 55.5a8.3 8.3 0 018.3-6.7c4.2 0 6.3 2.5 5.6 6.4a8.5 8.5 0
							01-8.4 7c-4.8 0-6-3.7-5.5-6.7m11.4.3c.7-3.8-1-6.2-3.8-6.2-2 0-4.4
							1.1-5.2 5.4-.6 3.5.8 6.4 4 6.4 1.2 0 4-.6 5-5.6" />
						<path
							d="M199.7 54.2l.7-3.6c0-.6 0-.9-.6-1a3.6 3.6 0 00-.6 0c-.2 0-.3
							0-.3-.2l.4-.2 2.5.1h2.4c2.1 0 2.8.7 3 1a2.5 2.5 0 01.4 2 5 5 0
							01-5 4 2.3 2.3 0 01-.3 0s-.2 0-.1-.1c0-.2.1-.2.5-.2a3.4 3.4 0
							002.8-2.8 2.9 2.9 0 00-.5-2.6 2 2 0 00-1.6-.6 2.6 2.6 0 00-.7
							0l-.2.4-1.3 6.8a42 42 0 00-.6 3.6c0 .5 0 .8.5.9a6.1 6.1 0 00.8
							0c.2 0 .3.1.3.2l-.4.2h-4.7c-.2 0-.3 0-.3-.2l.3-.1a2.7 2.7 0
							00.6-.1c.3 0 .5-.4.7-1l.7-3.5.6-3" />
						<path
							d="M214 57.6l-.3.1-1.4 2.5a4 4 0 00-.5 1c0 .3 0 .6.6.6h.3l.2.1c0
							.1-.1.2-.3.2h-3.9c-.3 0-.4 0-.4-.2l.3-.1a5.3 5.3 0 00.5 0c.9-.2
							1.3-.8 1.8-1.6l6.6-10.8c.3-.5.4-.7.6-.7.2 0 .2.1.3.5l2.3 10.6c.4
							1.6.9 1.8 1.2 1.9a3.4 3.4 0 00.7 0c.2 0 .3 0 .2.2 0
							.1-.2.2-.8.2h-3.3c-.4 0-.6 0-.5-.2l.2-.2a.3.3 0
							00.3-.4l-.7-3.6a.1.1 0 00-.1-.1h-4m3.8-.9s.1 0 0
							0l-.6-4.3-.1-.2-.2.2-2.4 4.2v.1z" />
						<path
							d="M229.8 54.2l.6-3.6c.1-.6 0-.9-.5-1a3.8 3.8 0 00-.7 0c-.2 0-.3
							0-.3-.2l.4-.1h6.9l.7-.1a2.2 2.2 0 01.3 0h.1l-.4 1.2-.3 1.1s0
							.2-.2.2-.1-.1 0-.3a1.7 1.7 0 000-.6c-.1-.3-.3-.5-1.1-.6a63.6 63.6
							0 00-2.6.1l-.8 4.3v.2h2.8a1.5 1.5 0 00.9-.3l.3-.2.1.1-.4 1.3-.3
							1.1c0 .1 0 .3-.2.3l-.1-.1a4.8 4.8 0 000-.6c0-.4-.2-.6-.8-.7a61.3
							61.3 0 00-2.5 0v.1l-.4 1.4-.5 2.6c-.2 1.2 0 1.4 1.8 1.4a4.9 4.9 0
							001.7-.2 1.9 1.9 0 001-1.2c.1-.2.1-.3.3-.3v.3a14.8 14.8 0 01-.5
							1.9c-.2.4-.4.4-1 .4h-3a44 44 0 00-2.8 0H227c-.2 0-.3
							0-.3-.2l.3-.1a2.9 2.9 0 00.7-.1c.3 0 .5-.4.7-1l.8-3.5.6-3" />
						<path
							d="M244.8 54l.7-3.6c0-.6 0-.8-.5-1a3.6 3.6 0 00-.7 0c-.2 0-.3
							0-.2-.2l.4-.1h5c2.1 0 5 0 6.4 2a5.3 5.3 0 01.8 4.3 8.6 8.6 0
							01-2.7 4.8 9.1 9.1 0 01-6 2h-2l-1.6-.2h-2.2l-.3-.1.3-.1a2.7 2.7 0
							00.6-.1c.4 0 .5-.4.7-1l.8-3.6.6-3m1.7 1.9l-.6 3.4a3.8 3.8 0 000
							1.3c0 .4.7.7 2 .7a6.3 6.3 0 004.1-1.2 6.7 6.7 0 002.3-4.3 5 5 0
							00-.8-4.3 5.6 5.6 0 00-4.5-1.7 4.7 4.7 0 00-1.1.1.4.4 0
							00-.3.4l-.7 3.4z" />
						<path
							d="M264.4 54.1l.7-3.5c0-.6 0-.9-.4-1a2.6 2.6 0 00-.7 0c-.2 0-.3
							0-.2-.2 0-.1.1-.2.4-.2l2.4.1h2.5c0 .2-.1.3-.3.3a3.8 3.8 0 00-.6
							0c-.5 0-.7.4-.8 1l-.8 3.6-.6 3-.7 3.6c0 .5 0 .8.6.9a7 7 0 00.9
							0c.2 0 .2 0 .2.2l-.4.1h-5l-.4-.1c0-.1.1-.2.4-.2a3.1 3.1 0 00.6
							0c.4-.1.6-.4.7-.9.3-.7.5-2 .9-3.7l.6-3" />
						<path
							d="M274.9 60.5a5.3 5.3 0 01-1.2-5 7.9 7.9 0 013-4.7 9.3 9.3 0
							015.9-1.8 17.4 17.4 0 012.5.2l1.7.3c.2 0 .2.1.2.2l-.3 1-.4 1.8c0
							.2-.1.4-.3.4-.1 0-.1-.2 0-.4a2 2 0 00-.4-1.6 4.5 4.5 0 00-3.4-1
							5.5 5.5 0 00-3.5 1 6.9 6.9 0 00-2.5 4.4c-.8 4 2 6 4.3 6 1.6 0
							2.6-.1 3.4-1a3.6 3.6 0 00.8-1l.3-.4c.2 0 .2.1.1.3a17.9 17.9 0
							01-.8 2.2.8.8 0 01-.5.5 11.3 11.3 0 01-3.3.4c-2.4 0-4.3-.5-5.6-1.8" />
						<path
							d="M291 61.9c-.3-.2-.3-.2-.2-.6l.5-2.3c0-.2.2-.4.3-.4l.1.3a3.4 3.4
							0 000 .8 1.9 1.9 0 002.2 1.8 2.7 2.7 0 002.7-2c.1-.8
							0-1.6-1.2-2.7l-.7-.6c-1.6-1.5-2-2.7-1.8-4.1.4-2 2.3-3.3
							4.7-3.3a7.8 7.8 0 012.2.3c.2 0 .2.1.2.2l-.5 2.1c0 .4-.1.5-.2.5-.2
							0-.2 0-.2-.3a1.8 1.8 0 00-.2-1.1 1.8 1.8 0 00-1.7-.9 2.3 2.3 0
							00-2.4 1.8c-.2.8.1 1.4 1.3 2.5l.4.3c1.8 1.6 2.4 2.8 2 4.4a4.4 4.4
							0 01-2.2 3 5.7 5.7 0 01-2.9.7 5.5 5.5 0 01-2.4-.4" />
						<path
							d="M85.3 78.5a.6.6 0 01.5.2.7.7 0 010 1 .7.7 0 01-.4.2.6.6 0
							01-.5-.2.7.7 0 010-1 .6.6 0 01.4-.2" />
						<path
							d="M88.8 78.5a.6.6 0 01.4.2.7.7 0 010 1 .7.7 0 01-.4.2.6.6 0
							01-.5-.2.7.7 0 010-1 .6.6 0 01.5-.2" />
						<path
							d="M92.2 78.5a.6.6 0 01.4.2.7.7 0 010 1 .7.7 0 01-.4.2.6.6 0
							01-.5-.2.7.7 0 010-1 .6.6 0 01.5-.2" />
						<path
							d="M98.4 70L97 74.8a4.8 4.8 0 011.2-1 2 2 0 011-.2 1.5 1.5 0
							011.2.5 1.9 1.9 0 01.4 1.3 4.5 4.5 0 01-.6 2.2 4.8 4.8 0 01-1.5
							1.7 3.3 3.3 0 01-1.8.7 3.5 3.5 0 01-2.1-.8l2-7.2a6.5 6.5 0 00.3-1
							.3.3 0 00-.2-.2.7.7 0 00-.4-.2 2.7 2.7 0 00-.4 0v-.2l2.3-.4m-2.6
							9.3a2.5 2.5 0 001.2.3 2.1 2.1 0 001.2-.4 3.5 3.5 0 001-1.5 5.2 5.2
							0 00.5-2.1 1.5 1.5 0 00-.3-1 1 1 0 00-.7-.4 1.8 1.8 0 00-1.2.6 2.8
							2.8 0 00-.8 1.4z" />
						<path
							d="M102.9 77.2a4.4 4.4 0 000 .6 1.4 1.4 0 00.3 1 1.4 1.4 0 001 .4
							2.2 2.2 0 001-.2 7.3 7.3 0 001.3-.9l.1.2a4.4 4.4 0 01-3 1.7 1.7
							1.7 0 01-1.4-.7 2.3 2.3 0 01-.5-1.4 4.3 4.3 0 01.6-2.1 4.8 4.8 0
							011.5-1.7 3.5 3.5 0 012-.6 1.6 1.6 0 011 .3 1 1 0 01.3.7 1.7 1.7 0
							01-.4 1.1 4 4 0 01-1.7 1.1 9.2 9.2 0 01-2.1.5m0-.4a5.5 5.5 0
							001.6-.4 3.3 3.3 0 001.3-.9 1.7 1.7 0 00.4-1 .7.7 0 00-.2-.5.7.7 0
							00-.5-.1 2.2 2.2 0 00-1.5.7 4.6 4.6 0 00-1 2.2" />
						<path
							d="M112.6 78.3a5 5 0 01-1.4 1.3 3 3 0 01-1.5.4 2 2 0 01-1.5-.6 2 2
							0 01-.5-1.5 4.3 4.3 0 01.5-2 4.7 4.7 0 011.6-1.7 3.4 3.4 0
							011.8-.7 1.6 1.6 0 011.1.3 1 1 0 01.4.8 1.1 1.1 0 01-.3.7.6.6 0
							01-.4.3.5.5 0 01-.4-.2.5.5 0 010-.3.6.6 0 010-.3 1 1 0 01.2-.2 1 1
							0 00.2-.2.3.3 0 000-.2.3.3 0 00-.1-.2 1 1 0 00-.6-.2 2.1 2.1 0
							00-1.3.5 3.9 3.9 0 00-1 1.4 4.7 4.7 0 00-.6 2.1 1.6 1.6 0 00.4 1.1
							1.4 1.4 0 001 .4 2.1 2.1 0 001-.2 4.3 4.3 0 001.2-1l.2.2" />
						<path
							d="M119.7 73.5l-1.3 4.7-.1.6a.7.7 0 000 .2.3.3 0 000 .2.2.2 0 00.2
							0 .4.4 0 00.2 0 4 4 0 00.7-.9l.2.2a4.2 4.2 0 01-1 1 1.5 1.5 0
							01-.8.5.6.6 0 01-.5-.2.6.6 0 01-.1-.4 3.7 3.7 0 01.1-1l.2-.4a6.6
							6.6 0 01-1.6 1.6 1.9 1.9 0 01-1 .4 1 1 0 01-.9-.5 1.8 1.8 0
							01-.3-1.1 5 5 0 01.6-2.3 5.7 5.7 0 011.6-2 2.4 2.4 0 011.5-.6 1 1
							0 01.6.2 1.4 1.4 0 01.4.8l.3-.8 1-.2m-2.3.4a1.4 1.4 0 00-1 .4 6 6
							0 00-1.7 3.8 1.1 1.1 0 00.2.8.7.7 0 00.6.2q.7 0 1.5-1a5 5 0
							001.2-3.1 1.3 1.3 0 00-.2-.9.7.7 0 00-.6-.2" />
						<path
							d="M126.6 73.7l-1.2 4.1a6 6 0 00-.2 1.2.3.3 0 000 .2.1.1 0 00.1 0
							.4.4 0 00.3 0 6.7 6.7 0 00.7-1l.2.2a4.4 4.4 0 01-1.1 1.3 1.2 1.2 0
							01-.7.3.5.5 0 01-.4-.2.6.6 0 01-.2-.4 3 3 0
							01.1-.6c0-.4.3-1.1.6-2.2a13.2 13.2 0 01-1.9 2.6 2.2 2.2 0
							01-1.4.8.7.7 0 01-.5-.3.8.8 0 01-.2-.5 6.8 6.8 0
							01.3-1.6l.5-2.2a5.1 5.1 0 00.2-1 .2.2 0 00-.1-.1.5.5 0 00-.3 0 5.4
							5.4 0 00-.6.9l-.2-.2a3.9 3.9 0 011-1.2 1.4 1.4 0 01.8-.3.5.5 0
							01.4.2.6.6 0 01.2.4 6 6 0 01-.3 1.3l-.6 2.3a6 6 0 00-.3 1.1.3.3 0
							000 .2.3.3 0 00.3.1 1.2 1.2 0 00.6-.2 4.5 4.5 0 001-1 13.4 13.4 0
							00.9-1.5 11.4 11.4 0 00.8-2.2l.2-.5h1" />
						<path
							d="M132 73.5l-.5 2.1h-.2a2.3 2.3 0 00-.4-1.3 1 1 0 00-.9-.4.9.9 0
							00-.6.2.8.8 0 00-.3.6 1 1 0 00.1.4 2.8 2.8 0 00.4.6 8.4 8.4 0
							011.2 1.5 2.1 2.1 0 01.2 1 1.7 1.7 0 01-.6 1.2 2 2 0 01-1.4.6 3.2
							3.2 0 01-1.1-.3 1 1 0 00-.4 0 .5.5 0 00-.4.3h-.3l.4-2.3h.3a2.4 2.4
							0 00.4 1.5 1.3 1.3 0 001 .4 1 1 0 00.8-.3 1 1 0 00.3-.7 1.2 1.2 0
							000-.5 5.8 5.8 0 00-.8-1.1 6.2 6.2 0 01-.8-1.1 1.7 1.7 0 01-.2-.8
							1.5 1.5 0 01.5-1.1 1.6 1.6 0 011.2-.5 2 2 0 01.4 0 4 4 0 01.4.2
							1.7 1.7 0 00.5.1.6.6 0 00.5-.3h.2" />
						<path
							d="M133.9 77.2a4.4 4.4 0 000 .6 1.4 1.4 0 00.4 1 1.4 1.4 0 001 .4
							2.2 2.2 0 001-.2 7.3 7.3 0 001.2-.9l.2.2a4.4 4.4 0 01-3 1.7 1.7
							1.7 0 01-1.5-.7 2.3 2.3 0 01-.5-1.4 4.3 4.3 0 01.6-2.1 4.8 4.8 0
							011.5-1.7 3.5 3.5 0 012-.6 1.6 1.6 0 011 .3 1 1 0 01.3.7 1.7 1.7 0
							01-.4 1.1 4 4 0 01-1.7 1.1 9.2 9.2 0 01-2.1.5m0-.4a5.5 5.5 0
							001.6-.4 3.3 3.3 0 001.3-.9 1.7 1.7 0 00.4-1 .7.7 0 00-.2-.5.7.7 0
							00-.5-.1 2.1 2.1 0 00-1.4.7 4.6 4.6 0 00-1.2 2.2" />
						<path
							d="M145.8 70l-2.3 8.2a4.5 4.5 0 00-.2.7.2.2 0 00.1.2.2.2 0 00.2 0
							.5.5 0 00.2 0 3.8 3.8 0 00.8-1l.2.3a5 5 0 01-1.2 1.3 1.4 1.4 0
							01-.7.3.6.6 0 01-.5-.2.6.6 0 01-.2-.4 5 5 0 01.3-1l1.8-6.6a6.8 6.8
							0 00.2-.9.3.3 0 00-.1-.3.6.6 0 00-.4 0 3.1 3.1 0 00-.5
							0v-.3l2.3-.4" />
						<path
							d="M148.7 73.5l-1.4 4.9a3.7 3.7 0 00-.1.6.3.3 0 000 .1.2.2 0
							00.2.1.4.4 0 00.3 0 4.1 4.1 0 00.7-1l.3.2a4.8 4.8 0 01-1.1 1.2 1.4
							1.4 0 01-.9.4.6.6 0 01-.4-.2.6.6 0 01-.2-.4 3.7 3.7 0
							01.2-.9l.8-3a5.1 5.1 0 00.2-1 .3.3 0 000-.3.4.4 0 00-.3-.1 5.3 5.3
							0 00-.6 0V74l2.3-.4m-.1-2.7a.6.6 0 01.4.2.7.7 0 010 1 .7.7 0 01-1
							0 .7.7 0 010-1 .6.6 0 01.6-.2" />
						<path
							d="M149.6 74l2-.5a7.2 7.2 0 01.2 1 15.1 15.1 0 01.3 2l.2 2.2 1-1.2
							1-1.4a3 3 0 00.3-.7 1.2 1.2 0 000-.4l-.2-.4a.7.7 0 01-.4-.5.6.6 0
							01.6-.6.6.6 0 01.5.3.9.9 0 01.2.5 2.2 2.2 0 010 .7 6.5 6.5 0 01-.7
							1.3 21.3 21.3 0 01-1.5 2l-1.5 1.6h-.3a19 19 0 00-.6-5.4.6.6 0
							00-.6-.4 2.5 2.5 0 00-.5 0V74" />
						<path
							d="M158.5 73.5l-1.3 4.9a3.7 3.7 0 00-.2.6.3.3 0 00.1.1.2.2 0
							00.1.1.4.4 0 00.3 0 4.1 4.1 0 00.8-1l.2.2a4.8 4.8 0 01-1 1.2 1.4
							1.4 0 01-1 .4.6.6 0 01-.4-.2.6.6 0 01-.2-.4 3.8 3.8 0
							01.2-.9l.9-3a5.1 5.1 0 00.2-1 .3.3 0 00-.1-.3.4.4 0 00-.3-.1 5.3
							5.3 0 00-.6 0V74l2.3-.4m-.1-2.7a.6.6 0 01.5.2.7.7 0 010 1 .7.7 0
							01-1 0 .7.7 0 010-1 .6.6 0 01.5-.2" />
						<path
							d="M162.1 73.5l-.8 3.2a14.7 14.7 0 011.9-2.6 2 2 0 011.2-.6.7.7 0
							01.6.2.8.8 0 01.2.6 4.4 4.4 0 01-.2 1.2l-.8 2.9a3.5 3.5 0
							00-.1.6.3.3 0 000 .2.1.1 0 00.1 0 .3.3 0 00.2 0 4.6 4.6 0
							00.8-1l.2.2a5.2 5.2 0 01-1.2 1.3 1.3 1.3 0 01-.7.3.5.5 0
							01-.4-.2.6.6 0 01-.1-.4 5.1 5.1 0 01.2-1.2l.8-2.8a3.3 3.3 0
							00.1-.8.3.3 0 000-.2.3.3 0 00-.3 0 .8.8 0 00-.4.1 4 4 0 00-1 1
							14.6 14.6 0 00-1.1 1.8 7 7 0 00-.6 1.3l-.3 1.2h-1l1.2-4.4a5.8 5.8
							0 00.2-.9.4.4 0 000-.3.4.4 0 00-.4 0 2 2 0 00-.3 0h-.2v-.3l2.2-.4" />
						<path
							d="M173 74l-.1.7h-1.1a2.1 2.1 0 01-.7 2.3 3.2 3.2 0 01-2 .8 3 3 0
							00-1.1.5.3.3 0 00-.1.2.3.3 0 000 .3 1.5 1.5 0 00.7.2l1.3.3a3 3 0
							011.4.7 1.2 1.2 0 01.4.8 1.6 1.6 0 01-.4 1 2.7 2.7 0 01-1.2.8 5.4
							5.4 0 01-1.7.2 5.1 5.1 0 01-1.5-.2 2 2 0 01-1-.5 1 1 0 01-.3-.7
							1.2 1.2 0 01.2-.6 1.7 1.7 0 01.5-.6l1-.6a.7.7 0 01-.3-.5 1 1 0
							01.2-.6 3.3 3.3 0 011.2-.7 2 2 0 01-1.2-.7 1.6 1.6 0 01-.4-1 2.4
							2.4 0 01.8-1.8 3.1 3.1 0 012.2-.8 2.7 2.7 0 01.8.1 2.1 2.1 0
							01.7.3h1.8m-5.5 5.9a2 2 0 00-.9.6 1.4 1.4 0 00-.2.8.9.9 0 00.4.8
							2.8 2.8 0 001.6.4 3.6 3.6 0 001.7-.3 1 1 0 00.6-.9.7.7 0 00-.2-.5
							2 2 0 00-1-.4l-2-.5m3.2-4.8a1.2 1.2 0 00-.3-.8 1 1 0 00-.8-.4 1.4
							1.4 0 00-1.3.8 3 3 0 00-.5 1.7 1.2 1.2 0 00.4.8 1 1 0 00.7.4 1.3
							1.3 0 00.7-.2 1.8 1.8 0 00.6-.6 3 3 0 00.3-.9 4 4 0 00.1-.8" />
						<path
							d="M181.9 73.5l.4 5.2a18.3 18.3 0 001.9-2.6 2.6 2.6 0 00.4-1 .5.5
							0 000-.4.6.6 0 00-.3-.1.7.7 0 01-.2-.3.5.5 0 01-.1-.3.5.5 0
							01.1-.3.5.5 0 01.4-.2.6.6 0 01.5.2.8.8 0 01.2.6 2.2 2.2 0 01-.1.7
							8 8 0 01-.8 1.5 26 26 0 01-2.6 3.5h-.2l-.4-4.8-2.8 4.8h-.3a39.9
							39.9 0 00-.3-4.7 1.7 1.7 0 00-.3-1 .7.7 0 00-.5-.1 4 4 0 00-.5
							0V74l2-.5a13.9 13.9 0 01.4 3.6l.1 1.1 2.7-4.7h.3" />
						<path
							d="M188.4 73.5l-1.3 4.9a3.8 3.8 0 00-.2.6.3.3 0 00.1.1.2.2 0
							00.2.1.5.5 0 00.2 0 4.2 4.2 0 00.8-1l.2.2a4.8 4.8 0 01-1 1.2 1.4
							1.4 0 01-1 .4.6.6 0 01-.4-.2.6.6 0 01-.2-.4 3.7 3.7 0
							01.2-.9l.9-3a5.1 5.1 0 00.2-1 .3.3 0 00-.1-.3.4.4 0 00-.3-.1 5.3
							5.3 0 00-.6 0V74l2.3-.4m-.1-2.7a.6.6 0 01.5.2.7.7 0 010 1 .7.7 0
							01-1 0 .7.7 0 010-1 .6.6 0 01.5-.2" />
						<path
							d="M193 71.8l-.6 1.9h1.2l-.1.4h-1.2l-1.3 4.1a3.8 3.8 0 00-.2.9.3.3
							0 000 .1.2.2 0 00.2.1 1 1 0 00.5-.2 8.1 8.1 0 00.8-.9l.2.2a5.1 5.1
							0 01-1.3 1.3 1.6 1.6 0 01-.8.3.8.8 0 01-.6-.2.6.6 0 01-.2-.5 4.3
							4.3 0 01.3-1.2l1.2-4H190v-.3a3.9 3.9 0 001.4-.6 5.8 5.8 0
							001.3-1.4h.3" />
						<path
							d="M197.3 70l-1.9 6.7a14 14 0 012-2.6 2 2 0 011.2-.6.7.7 0
							01.6.3.9.9 0 01.2.6 4 4 0 01-.2 1l-.8 3a5.2 5.2 0 00-.2.6.2.2 0
							000 .1.2.2 0 00.2 0 .3.3 0 00.2 0 4.1 4.1 0 00.8-.9l.1.2a5.5 5.5 0
							01-.6.8 3.1 3.1 0 01-.7.6 1 1 0 01-.5.2.5.5 0 01-.4-.2.6.6 0
							01-.1-.4 5.2 5.2 0 01.2-1.2l.8-2.7a3.2 3.2 0 00.1-.8.3.3 0
							00-.3-.4.8.8 0 00-.4.2 4.4 4.4 0 00-1 1l-1.1 1.8a5.3 5.3 0 00-.5
							1l-.4 1.5h-1l2.2-8 .2-.8a.4.4 0 00-.1-.3.5.5 0 00-.4-.2 2.3 2.3 0
							00-.4 0v.1-.3l2.2-.4" />
						<path
							d="M206.5 73.5l-.5 1.6a5.9 5.9 0 011.4-1.2 2.5 2.5 0 011.2-.4 1.4
							1.4 0 011.1.5 1.8 1.8 0 01.5 1.3 5 5 0 01-1.3 3 3.8 3.8 0 01-3 1.7
							2.5 2.5 0 01-.7-.1 2.9 2.9 0 01-.6-.3l-.5 1.8a3.2 3.2 0
							00-.2.7.4.4 0 00.1.2.5.5 0 00.3.2 3 3 0 00.7 0v.3h-3.4v-.2a1.6 1.6
							0 001-.2 2.5 2.5 0 00.4-1.1l1.9-6.1a3.8 3.8 0 00.1-.7.4.4 0
							000-.3.5.5 0 00-.4-.1 5.3 5.3 0 00-.6 0V74l2.5-.4m-1.7 5.6a1.5 1.5
							0 001.2.5 1.7 1.7 0 00.8-.2 3 3 0 00.7-.6 4.8 4.8 0 00.7-1 7.1 7.1
							0 00.5-1.1 4.4 4.4 0 00.3-1.4 1.2 1.2 0 00-.3-.9.8.8 0 00-.6-.3
							2.1 2.1 0 00-1.6.9 5.3 5.3 0 00-1 2z" />
						<path
							d="M216.7 73.5l-1.3 4.7-.2.6a.7.7 0 000 .2.3.3 0 000 .2.2.2 0 00.2
							0 .4.4 0 00.2 0 4 4 0 00.7-.9l.2.2a4.2 4.2 0 01-.9 1 1.5 1.5 0
							01-.9.5.6.6 0 01-.4-.2.6.6 0 01-.2-.4 3.6 3.6 0 01.2-1l.1-.4a6.6
							6.6 0 01-1.6 1.6 2 2 0 01-1 .4 1 1 0 01-.9-.5 1.7 1.7 0 01-.4-1.1
							5 5 0 01.7-2.3 5.7 5.7 0 011.6-2 2.5 2.5 0 011.5-.6 1 1 0 01.7.2
							1.4 1.4 0 01.4.8l.2-.8 1-.2m-2.3.4a1.4 1.4 0 00-1 .4 6 6 0 00-1.7
							3.8 1.1 1.1 0 00.2.8.7.7 0 00.6.2q.7 0 1.6-1A5 5 0 00215 75a1.3
							1.3 0 00-.2-.9.7.7 0 00-.6-.2" />
						<path
							d="M220 73.5l-1.3 4.9a3.7 3.7 0 000 .5.3.3 0 000 .2.2.2 0
							00.1.1.4.4 0 00.3-.1 4.2 4.2 0 00.7-.9l.3.2a4.9 4.9 0 01-1.1 1.2
							1.4 1.4 0 01-.9.4.6.6 0 01-.4-.2.6.6 0 01-.2-.5 3.7 3.7 0
							01.2-.8l.8-3.1a5.5 5.5 0 00.3-1 .3.3 0 00-.1-.2.4.4 0 00-.3-.1 5.3
							5.3 0 00-.6 0V74l2.3-.4m-.1-2.7a.6.6 0 01.4.2.7.7 0 010 1 .7.7 0
							01-.9 0 .7.7 0 01-.2-.6.7.7 0 01.2-.4.6.6 0 01.5-.2" />
						<path
							d="M224 73.5l-.9 3.1a14.5 14.5 0 012-2.5 2 2 0 011.2-.6.7.7 0
							01.6.2.8.8 0 01.2.6 4.4 4.4 0 01-.2 1l-.8 3a3.8 3.8 0 00-.2.6.3.3
							0 000 .2.1.1 0 00.2 0 .3.3 0 00.2 0 4.5 4.5 0 00.8-1l.2.2a5.2 5.2
							0 01-1.2 1.3 1.3 1.3 0 01-.7.3.5.5 0 01-.4-.2.6.6 0 01-.1-.4 5 5 0
							01.2-1.1l.8-2.8a3.2 3.2 0 00.1-.8.3.3 0 000-.2.3.3 0 00-.3-.1.9.9
							0 00-.4.1 4 4 0 00-1 1 14.5 14.5 0 00-1.2 1.9 7 7 0 00-.5 1.3l-.3
							1.1h-1l1.2-4.3a5.8 5.8 0 00.2-1 .4.4 0 00-.1-.2.4.4 0 00-.3-.1 2.2
							2.2 0 00-.3 0h-.3V74l2.3-.4" />
						<path
							d="M234.5 73.7l-1.4 4.8a2.7 2.7 0 000 .5.2.2 0 000 .2.2.2 0 00.1 0
							.3.3 0 00.3 0 4.2 4.2 0 00.7-1l.2.2q-1 1.8-2.2 1.8a1 1 0
							01-.6-.3.8.8 0 01-.3-.6 2.4 2.4 0 01.1-.6l1-3.3a3 3 0 000-.7.4.4 0
							000-.3.5.5 0 00-.4-.1h-.2V74l2.3-.3h.4m-.4-3.2a1 1 0 01.7.3 1 1 0
							010 1.4 1 1 0 01-.7.3 1 1 0 01-.7-.3 1 1 0 01-.3-.7 1 1 0 01.3-.7
							1 1 0 01.7-.3" />
						<path
							d="M239.8 73.4l-.2 2.1h-.3a2.1 2.1 0 00-.5-1.3 1.3 1.3 0
							00-1-.5.7.7 0 00-.4.2.6.6 0 00-.2.5 1 1 0 000 .4 2.3 2.3 0 00.5.5
							10.4 10.4 0 011.2 1.6 2 2 0 01.3 1 2.1 2.1 0 01-.3 1 2 2 0 01-.8.8
							2.2 2.2 0 01-1.1.3 3.8 3.8 0 01-1-.2 2.1 2.1 0 00-.5 0 .6.6 0
							00-.3 0 .7.7 0 00-.2.2h-.2l.3-2.3h.2a5.7 5.7 0 00.5 1.2 1.6 1.6 0
							00.5.5 1.2 1.2 0 00.7.3.8.8 0 00.6-.3.8.8 0 00.2-.6 1.4 1.4 0
							00-.2-.6 5.8 5.8 0 00-.7-1 7.5 7.5 0 01-1-1.3 1.8 1.8 0 01-.2-.8
							1.7 1.7 0 01.5-1.2 2 2 0 011.5-.5 4.2 4.2 0 011 .1 2.1 2.1 0 00.5
							0 .5.5 0 00.4-.1h.3" />
						<path
							d="M243.6 73.5l-.8 3a17.4 17.4 0 011.2-1.8 4.4 4.4 0 011-1 1.7 1.7
							0 01.9-.2.8.8 0 01.6.2 1 1 0 01.2.7 3.5 3.5 0 01-.1 1l-.9 3a2.4
							2.4 0 00-.1.4.2.2 0 000 .2.1.1 0 00.1 0 .2.2 0 00.2 0 2.6 2.6 0
							00.4-.6l.2-.3.3.2c-.7 1.1-1.3 1.7-2 1.7a.9.9 0 01-.7-.2.7.7 0
							01-.2-.6 3.4 3.4 0 01.1-.9l.9-3a1.7 1.7 0 000-.4.2.2 0 00-.2-.2 1
							1 0 00-.6.4 9.8 9.8 0 00-1.7 2.7l-.6 2.1h-1.7l1.3-4.5a4.3 4.3 0
							00.1-.9.3.3 0 000-.2.4.4 0 00-.2-.1 1.6 1.6 0 00-.4
							0v-.3l2.3-.4h.4" />
						<path
							d="M247.7 74.7l-.2-.3a4.9 4.9 0 001.3-.9.8.8 0 00.2-.5.9.9 0
							00-.4-.6 2.3 2.3 0 01-.4-.5 1 1 0 01-.1-.5 1.1 1.1 0 011-1 1 1 0
							01.9.3 1.3 1.3 0 01.3 1 2.8 2.8 0 01-.6 1.6 4.7 4.7 0 01-2 1.4" />
						<path
							d="M254.5 71.7l-.6 2h1l-.3.7h-.9l-1 4a2.3 2.3 0 00-.2.6.2.2 0 000
							.1.2.2 0 00.2.1.4.4 0 00.2 0 4 4 0 00.7-1l.3.2a3.5 3.5 0 01-1 1.2
							1.9 1.9 0 01-1.1.4 1 1 0 01-.7-.2.8.8 0 01-.3-.6 4 4 0
							01.2-1l1-3.8h-.8v-.5a5.9 5.9 0 001.5-.8 9.1 9.1 0 001.4-1.4h.4" />
						<path
							d="M258.4 74.2l2.3-.4-1 3.4a11.2 11.2 0 012.2-3 1.5 1.5 0
							01.9-.4.4.4 0 01.3.1.5.5 0 01.1.4 1.8 1.8 0 01-.2.9.5.5 0
							01-.5.3.4.4 0 01-.2-.1.5.5 0 01-.1-.3.3.3 0 00-.1-.2.2.2 0 00-.1 0
							.4.4 0 00-.2 0 2.2 2.2 0 00-.6.5 15.1 15.1 0 00-1.2 1.8 5.2 5.2 0
							00-.5 1l-.3 1-.2.9h-1l1.2-4.3a4.5 4.5 0 00.2-1.1.3.3 0 000-.2.5.5
							0 00-.4-.1 3.9 3.9 0 00-.5 0v-.2" />
						<path
							d="M264.4 77.3a4.3 4.3 0 000 .6 1.4 1.4 0 00.4 1 1.4 1.4 0 001 .4
							2.2 2.2 0 001-.2 7.2 7.2 0 001.3-.9l.1.2a4.4 4.4 0 01-3 1.7 1.7
							1.7 0 01-1.5-.7 2.2 2.2 0 01-.5-1.4 4.3 4.3 0 01.6-2.1 4.7 4.7 0
							011.6-1.7 3.5 3.5 0 011.9-.6 1.6 1.6 0 011 .3 1 1 0 01.4.7 1.7 1.7
							0 01-.5 1.1 4 4 0 01-1.7 1.1 9.2 9.2 0 01-2 .5m0-.4a5.5 5.5 0
							001.6-.4 3.3 3.3 0 001.2-.9 1.7 1.7 0 00.4-1 .6.6 0 00-.2-.5.7.7 0
							00-.5-.1 2.2 2.2 0 00-1.4.7 4.6 4.6 0 00-1.1 2.2" />
						<path
							d="M275 73.7l-1.3 4.7-.2.6a1 1 0 000 .2.3.3 0 000 .2.2.2 0 00.2 0
							.4.4 0 00.2 0 3.9 3.9 0 00.7-.9l.2.2a4.3 4.3 0 01-.9 1 1.5 1.5 0
							01-.9.5.6.6 0 01-.4-.2.6.6 0 01-.2-.4 3.5 3.5 0 01.2-1l.1-.4a6.6
							6.6 0 01-1.6 1.6 1.9 1.9 0 01-1 .4 1 1 0 01-.9-.5 1.7 1.7 0
							01-.3-1.1 5 5 0 01.6-2.3 5.6 5.6 0 011.6-2 2.4 2.4 0 011.5-.6 1 1
							0 01.7.2 1.4 1.4 0 01.4.8l.2-.8 1-.2m-2.3.4a1.4 1.4 0 00-1 .4 6 6
							0 00-1.6 3.8 1.1 1.1 0 00.2.8.7.7 0 00.5.2c.5 0 1-.3 1.6-1a5 5 0
							001.1-3.1 1.4 1.4 0 00-.2-.9.8.8 0 00-.6-.2" />
						<path
							d="M279.4 70l-2.3 8.2a4.3 4.3 0 00-.2.7.3.3 0 000 .2.2.2 0 00.2 0
							.4.4 0 00.3 0 3.7 3.7 0 00.7-1l.2.3a4.9 4.9 0 01-1.1 1.3 1.4 1.4 0
							01-.8.3.6.6 0 01-.4-.2.6.6 0 01-.2-.4 5.3 5.3 0 01.2-1l1.8-6.6a7.1
							7.1 0 00.3-.9.3.3 0 00-.2-.3.6.6 0 00-.3 0 3.1 3.1 0 00-.5
							0v-.3l2.3-.4" />
						<path
							d="M283.1 70l-2.3 8.2a4.4 4.4 0 00-.1.7.2.2 0 000 .2.2.2 0 00.2 0
							.4.4 0 00.3 0 3.7 3.7 0 00.7-1l.2.3a5 5 0 01-1.2 1.3 1.4 1.4 0
							01-.7.3.6.6 0 01-.4-.2.6.6 0 01-.2-.4 5 5 0 01.2-1l1.8-6.6a6.8 6.8
							0 00.2-.9.3.3 0 000-.3.6.6 0 00-.5 0 3.1 3.1 0 00-.5 0v-.3l2.3-.4" />
						<path
							d="M285.2 73.5a3 3 0 01.3.8 10.6 10.6 0 01.2 1.3l.3 3.4a33.2 33.2
							0 002-3 5.4 5.4 0 00.4-.7.7.7 0 000-.3.7.7 0 00-.2-.2.7.7 0
							01-.5-.7.6.6 0 01.2-.4.5.5 0 01.4-.2.6.6 0 01.5.3 1 1 0 01.2.7 2.8
							2.8 0 01-.4 1.2 20 20 0 01-1.4 2.2l-2.4 3.1a8.2 8.2 0 01-1.5 1.5
							1.6 1.6 0 01-.9.3.5.5 0 01-.3-.1.5.5 0 01-.2-.4.7.7 0 01.2-.5.7.7
							0 01.5-.2.4.4 0 01.2 0 .4.4 0 01.1.3.8.8 0 00.1.2.1.1 0 00.1 0
							.3.3 0 00.2 0 5.1 5.1 0 00.8-.8 12.6 12.6 0 001-1.1l-.4-4.4a3.2
							3.2 0 00-.3-1.3.7.7 0 00-.6-.3h-.5V74l1.9-.5" />
						<path
							d="M296.8 70l-2.3 8.2a4.5 4.5 0 00-.2.7.3.3 0 000 .2.2.2 0 00.2 0
							.4.4 0 00.3 0 3.6 3.6 0 00.7-1l.2.3a4.9 4.9 0 01-1.1 1.3 1.3 1.3 0
							01-.8.3.6.6 0 01-.4-.2.6.6 0 01-.2-.4 5.1 5.1 0 01.2-1l1.8-6.6a7.1
							7.1 0 00.3-.9.3.3 0 00-.2-.3.6.6 0 00-.4 0 3.1 3.1 0 00-.4
							0v-.3l2.3-.4" />
						<path
							d="M299.3 73.6l-1.3 4.9a4 4 0 00-.1.6.3.3 0 000 .1.2.2 0
							00.2.1.5.5 0 00.2 0 4.2 4.2 0 00.8-1l.2.2a4.9 4.9 0 01-1 1.2 1.4
							1.4 0 01-1 .4.6.6 0 01-.4-.2.6.6 0 01-.1-.4 3.6 3.6 0
							01.1-.9l.9-3a5.1 5.1 0 00.2-1 .3.3 0 00-.1-.3.4.4 0 00-.3-.1 5.1
							5.1 0 00-.6 0V74l2.3-.4m0-2.7a.6.6 0 01.4.2.7.7 0 010 1 .7.7 0
							01-1 0 .7.7 0 01-.2-.6.7.7 0 01.2-.4.6.6 0 01.5-.2" />
						<path
							d="M300.5 74l2-.5a7.2 7.2 0 01.3 1 15.7 15.7 0 01.2 2l.2 2.2 1-1.2
							1-1.4a3 3 0 00.3-.7 1.2 1.2 0 000-.4l-.2-.4a.7.7 0 01-.4-.5.5.5 0
							01.2-.4.6.6 0 01.4-.2.6.6 0 01.5.2.8.8 0 01.2.6 2.2 2.2 0 010 .7
							6.4 6.4 0 01-.7 1.3 21 21 0 01-1.6 2l-1.4 1.6h-.3a18.8 18.8 0
							00-.6-5.4.6.6 0 00-.6-.4 2.5 2.5 0 00-.5 0V74" />
						<path
							d="M309.1 73.8l-1.3 4.7a3.6 3.6 0 00-.1.6.3.3 0 000 .2.2.2 0 00.2
							0 .5.5 0 00.2 0 4.1 4.1 0 00.8-1l.2.2a4.7 4.7 0 01-1 1.2 1.4 1.4 0
							01-.9.4.6.6 0 01-.4-.2.6.6 0 01-.2-.4 3.5 3.5 0 01.1-.9l1-3a4.8
							4.8 0 00.1-1 .3.3 0 000-.2.4.4 0 00-.4 0 5.3 5.3 0 00-.6
							0v-.3l2.3-.3m0-2.7a.7.7 0 01.4.2.7.7 0 010 1 .7.7 0 01-1 0 .7.7 0
							010-1 .7.7 0 01.5-.2" />
						<path
							d="M313.1 73.7l-.9 3.2a14.6 14.6 0 012-2.6 2 2 0 011.2-.6.7.7 0
							01.6.2.8.8 0 01.2.6 4.3 4.3 0 01-.2 1.1l-.8 3a3.5 3.5 0
							00-.2.6.2.2 0 000 .1.1.1 0 00.2.1.3.3 0 00.2 0 4.6 4.6 0
							00.8-1l.2.2a5.2 5.2 0 01-1.2 1.3 1.3 1.3 0 01-.7.3.5.5 0
							01-.4-.2.6.6 0 01-.1-.4 5.2 5.2 0 01.2-1.2l.8-2.8a3.3 3.3 0
							00.1-.8.3.3 0 000-.2.3.3 0 00-.3 0 .8.8 0 00-.4.1 4.2 4.2 0 00-1 1
							14.6 14.6 0 00-1.2 1.9 6.8 6.8 0 00-.5 1.2l-.3 1.2h-1l1.2-4.4a5.9
							5.9 0 00.2-.9.4.4 0 00-.1-.3.4.4 0 00-.3 0 2 2 0 00-.3
							0h-.3v-.3l2.3-.4" />
						<path
							d="M323.8 74l-.2.7h-1a2.2 2.2 0 010 .7 2.2 2.2 0 01-.7 1.6 3.2 3.2
							0 01-2 .8 3 3 0 00-1.1.5.3.3 0 00-.2.2.3.3 0 00.2.3 1.5 1.5 0
							00.6.2l1.3.3a3 3 0 011.4.7 1.2 1.2 0 01.3.8 1.6 1.6 0 01-.4 1 2.6
							2.6 0 01-1.2.8 5.3 5.3 0 01-1.7.2 5.2 5.2 0 01-1.5-.2 2 2 0
							01-1-.5 1.1 1.1 0 01-.2-.7 1.3 1.3 0 01.2-.6 1.7 1.7 0 01.4-.6c.2
							0 .5-.3 1-.6a.7.7 0 01-.2-.5 1 1 0 01.2-.6 3.3 3.3 0 011.1-.7 2 2
							0 01-1.1-.7 1.6 1.6 0 01-.4-1 2.4 2.4 0 01.8-1.8 3.1 3.1 0
							012.2-.8 2.7 2.7 0 01.8.1 2.1 2.1 0 01.6.3h1.8m-5.5 5.9a2 2 0
							00-.8.6 1.4 1.4 0 00-.3.8 1 1 0 00.4.8 2.8 2.8 0 001.7.4 3.6 3.6 0
							001.6-.3 1 1 0 00.7-.9.7.7 0 00-.2-.5 2 2 0 00-1-.4 62.9 62.9 0
							01-2-.5m3.1-4.8a1.2 1.2 0 00-.3-.8 1 1 0 00-.8-.4 1.4 1.4 0
							00-1.2.8 3 3 0 00-.5 1.7 1.3 1.3 0 00.3.8 1 1 0 00.8.4 1.3 1.3 0
							00.7-.2 1.7 1.7 0 00.5-.6 3 3 0 00.4-.9 3.8 3.8 0 00.1-.8" />
						<path
							d="M325.3 78.7a.7.7 0 01.5.2.7.7 0 01.2.5.7.7 0 01-.2.5.7.7 0
							01-.5.2.7.7 0 01-.5-.2.7.7 0 01-.2-.5.7.7 0 01.2-.5.7.7 0
							01.5-.2m.5-1h-.3l.5-1.9.3-1.6.4-2.5a1.9 1.9 0 01.4-1 .5.5 0 01.4 0
							.4.4 0 01.3 0 .6.6 0 01.1.5 2.5 2.5 0 010 .7l-1.2 3-.4 1-.5 1.8" />
						<path
							d="M238 81.9h1.7c3.9.4 8.1.5 11.1
							1.7v.1c-5.2-.5-13-1.7-18.7-.3-1.1.3-2 1.3-3.2.5v-.3c2-1.5 5.7-1.4
							9-1.7" />
						<polygon
							fill="#fff"
							points="80,45 328,45 328,{$lowerPolygon[0]} 80,{$lowerPolygon[0]}" />
					</g>
					<!-- separator -->
					<g>
						<path fill="#002d62" d="M82.5 42.3h245v1.8h-245z" />
					</g>
					<!-- logo -->
					<!-- z top -->
					<path
						in:fly={{ y: -8, duration: 1300 }}
						d="M41.5 6.2L45.2 1V0H0v10h.6a11.9 11.9 0 011.8-4.7 6.7 6.7 0
						013.3-2.5 16.4 16.4 0 015.4-.7h26.4l-3.4 4.6a37.7 37.7 0
						016.3-.6h1.1"
						fill="#a9c5e7" />
					<!-- blue upper left -->
					<path
						in:fly={{ x: -8, y: -4, duration: 1300 }}
						d="M3.3 43.3a37.5 37.5 0 00.3 5L34.1 6.7A37.2 37.2 0 003.3 43.3"
						fill="#002d62" />
					<!-- blue right -->
					<path
						in:fly={{ x: 8, y: 4, duration: 1300 }}
						d="M73.2 32.6a19.2 19.2 0 00-7-4.1 24.4 24.4 0 00-7.6-1.3 20.4 20.4
						0 00-9 2 21.3 21.3 0 00-7.2 5.7 26.6 26.6 0 00-4.7 8.7 34.7 34.7 0
						00-1.6 9.5 16.1 16.1 0 004.3-.8 8 8 0 003.6-2.4 21 21 0
						002.3-3.8h.6l-2.6 9.2H36a34.2 34.2 0 001.7 10.3 25.2 25.2 0 004.7
						8.6 21 21 0 006.7 5.2 37.2 37.2 0 0028.5-36.1 38 38 0 00-.2-3.8 12.4
						12.4 0 00-4.2-6.9"
						fill="#002d62" />
					<!-- light blue upper middle -->
					<path
						in:fly={{ y: -4, x: 6, duration: 1300 }}
						d="M29.2 53.2A29.3 29.3 0 0133 40.5a29.8 29.8 0 0110.8-11 28.3 28.3
						0 0114.7-4 41.3 41.3 0 0110.5 1.4L73 28a11.6 11.6 0 001.4.2 37.2
						37.2 0 00-32.9-22L7 53.2h22.2"
						fill="#a9c5e7" />
					<!-- light blue lower middle -->
					<path
						in:fly={{ y: 4, x: -6, duration: 1300 }}
						d="M36.6 75a28.1 28.1 0 01-5.6-9.1 29.1 29.1 0
						01-1.9-10.5v-.1H5.2a37.2 37.2 0 0035.2 25.2c1 0 2.1 0 3.1-.2a26.4
						26.4 0 01-6.8-5.3"
						fill="#a9c5e7" />
					<!-- bottom thing -->
					<path
						in:fly={{ y: 6, x: 10, duration: 1300 }}
						d="M45.8 81.4a29.1 29.1 0 0011.9 2.4A26 26 0 0068 82a43.9 43.9 0
						009.1-5.7v-2a23.8 23.8 0 01-9 5.6 29 29 0 01-9.3 1.7 21.8 21.8 0
						01-9.1-1.9l-.6-.3a37 37 0 01-5.6 1l2.2 1"
						fill="#a9c5e7" />
				</svg>
			</div>
		{/if}
	</div>
{/if}
